import { AppointmentDTO, WindowRule } from "@gymflow/types";
import { DateTime } from "luxon";

export const canRescheduleAppointment = (
  appointment?: AppointmentDTO,
  rule?: WindowRule,
  timezone?: string,
): boolean => {
  if (!rule || !appointment) {
    return false;
  }

  const { windowValue, windowType } = rule;

  // if windowValue is 0 - can reschedule (because this value is for disable rule)
  if (windowValue === "0") {
    return true;
  }

  const appointmentStart = DateTime.fromISO(appointment.startDate).setZone(
    timezone,
  );
  const now = DateTime.now().setZone(timezone);

  const noticeWindow = appointmentStart.minus({
    [windowType.toLowerCase()]: Number(windowValue),
  });

  return now < noticeWindow;
};
